import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { Button } from "antd";
import ModalQR from "../ModalQR";

import logoAr from "../../../assets/images/logo/ARSHADES_AR_LOGO.svg";
import styles from "../../../styles/ModelViewer/ButtonAr.module.css"

export default function ARButton({ glRenderer, urlView, modelGlbUrl, modelUsdzUrl, onARStart, onAREnd }) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const mirror = queryParams?.get("mirror") ? true : false;

    const [isWebView, setIsWebView] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [isARActive, setIsARActive] = useState(false);

    const projectData = useSelector((state) => state.brandViewer);

    const currentUrl = urlView;
    const bgColor = projectData[0]?.qrBackGroundColor ?? "#ffffff";
    const fgColor = projectData[0]?.qrForeGroundColor ?? "#000000";

    const isAndroid = /Android/.test(navigator.userAgent);
    const isIOS = () => (
        /iPhone|iPad|iPod/.test(navigator.userAgent) ||
        (navigator.userAgent.includes("Macintosh") && 'ontouchend' in document)
    );

    const overlay = document.body.querySelector(".ar-overlay");

    const fallbackAR = () => {
        if (isAndroid && modelGlbUrl) {
            // SCENE VIEWER su Android
            const sceneViewerIntent = `intent://arvr.google.com/scene-viewer/1.0?file=${encodeURIComponent(modelGlbUrl)}&mode=ar_preferred#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(window.location.href)};end;`
            window.location.href = sceneViewerIntent;
        } else if (isIOS() && modelUsdzUrl) {
            // QUICK LOOK su iOS (.usdz richiesto)
            // NIENTE QUI: Quick Look è gestito dal <a rel="ar"> qui sotto

        } else {
            alert("AR not supported on this device/browser.");
        }
    }


    const startAR = async () => {
        if (navigator.xr) {
            const isSupported = await navigator.xr.isSessionSupported("immersive-ar");

            if (isSupported) {
                // WebXR supportato
                try {
                    const session = await navigator.xr.requestSession("immersive-ar", {
                        requiredFeatures: ["hit-test", "local-floor"],
                        optionalFeatures: ["bounded-floor", "dom-overlay"],
                        domOverlay: overlay ? { root: overlay } : undefined
                    });

                    session.addEventListener('end', () => {
                        setIsARActive(false);
                        onAREnd();
                    });

                    await glRenderer.xr.setSession(session);
                    setIsARActive(true);
                    onARStart();

                } catch (error) {
                    console.error("Error starting WebXR session:", error);
                    fallbackAR();
                }
            } else {
                fallbackAR();
            }
        }
    };

    function modalHandler() {
        setModalOpen(isOpen => !isOpen);
    }

    useEffect(() => {
        const userAgent = navigator.userAgent;
        const isWebView = /\bwv\b/.test(userAgent);
        if (isWebView) {
            setIsWebView(true);
        }
    }, []);

    const handleARButtonClick = () => {
        if (isMobile && !mirror) {
            // Su mobile, attiva AR
            startAR();
        } else {
            // Su desktop, apri il modale QR
            modalHandler();
        }
    };

    return (
        <>
            {!isWebView && !isARActive && !isIOS() && (  // Usa isARActive invece di modelViewer?.isPresenting
                <>
                    {isMobile && !mirror && (
                        <Button
                            className={styles["buttonARBottom"]}
                            icon={
                                <img
                                    src={projectData[0]?.ar_icon || logoAr}
                                    style={{ width: "40px", height: "40px" }}
                                    alt="ar"
                                />
                            }
                            shape="circle"
                            onClick={handleARButtonClick}
                        />
                    )}
                    {(!isMobile || mirror) &&
                        !(
                            projectData[0]?.menuPosition === "left" ||
                            projectData[0]?.menuPosition === "right"
                        ) && (
                            <div className={styles["button-right-bottom"]}>
                                <Button
                                    className={styles["button"]}
                                    icon={
                                        <img
                                            src={projectData[0]?.ar_icon || logoAr}
                                            style={{ width: "40px", height: "40px" }}
                                            alt="ar"
                                        />
                                    }
                                    shape="circle"
                                    onClick={handleARButtonClick}
                                />
                                {modalOpen && (
                                    <ModalQR
                                        fgColor={fgColor}
                                        bgColor={bgColor}
                                        url={currentUrl}
                                        modalHandler={modalHandler}
                                        modalOpen={modalOpen}
                                    />
                                )}
                            </div>
                        )}
                </>
            )}

            {isWebView && !isARActive && !isIOS() && (
                <Button
                    className={styles["buttonARBottomWebView"]}
                    shape="round"
                    onClick={startAR}
                >
                    View in AR
                </Button>
            )}

            {!isARActive && isIOS() && modelUsdzUrl && (
                <a
                    className={styles["buttonARBottom"]}
                    rel="ar"
                    href={modelUsdzUrl}
                >
                    <img
                        src={projectData[0]?.ar_icon || logoAr}
                        alt="ar"
                        style={{ width: "40px", height: "40px" }}
                    />
                </a>
            )}
        </>
    );
}